import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import Svg, { Circle, Rect } from 'react-native-svg';
import FontSizes from '../../../constants/FontSizes';
import { MainColors } from '../../../constants/Colors';
import { Fontisto } from '@expo/vector-icons';

const PieChart = (props) => {
    const [isPieVisible, setIsPieVisible] = useState(props.openInitially);

    const innerCircleRadius = 140 / 2;

    const circumference = 2 * Math.PI * innerCircleRadius;
    let angle = 90;

    const circles = props.percents.map((p, index) => {
        const arcLength = (p.percentOfVotes * circumference / 100);

        const offsetX = 2.8;
        const offsetY = 2.8;

        const circle = (
            <Circle r={innerCircleRadius} cx="140" cy="140" stroke={`${p.choiceColor}`} fill="transparent" strokeWidth="140" strokeDasharray={`${arcLength}` + ` ${circumference}`} transform={`rotate(${angle}, 140, 140) translate(${offsetX}, ${offsetY})`} />
        )

        angle += (p.percentOfVotes * 360) / 100;

        return circle;
    })

    const labels = props.percents.map((p, index) => {

        const voteLabel = p.numberOfVotes === 1 ? 'vote' : 'votes';

        return (
            <View style={styles.keyItem} key={index}>
                <Svg width="12" height="12" viewBox="0 0 12 12">
                    <Rect x="0" y="0" width="12" height="12" fill={p.choiceColor} />
                </Svg>
                <Text style={styles.keyItemLabel}>{p.choiceTitle}</Text>
                <Text style={styles.percentOfVotesLabel}> ({p.numberOfVotes} {voteLabel}, {p.percentOfVotes}%)</Text>
            </View>
        )
    })

    return (
        <>
            {isPieVisible ? (
                <View style={{ alignItems: 'center' }}>
                    <Svg width="180" height="180" viewBox="0 0 280 280">
                        {circles}

                        {/* overlaying circle to hide jagged edges */}
                        <Circle width="280" height="280" cx="140" cy="140" r="140" stroke="white" fill="transparent" strokeWidth="10" />
                    </Svg>

                    <View style={styles.detailsContainer}>
                        <View style={styles.keyContainer}>
                            {labels}
                        </View>
                    </View>
                </View>
            ) : (null)}

            {props.percents.every(bi => bi.numberOfVotes === 0) ? null :
                <TouchableOpacity style={styles.pieHideShowButton}
                    onPress={() => setIsPieVisible(!isPieVisible)}>
                    <Fontisto style={{ marginRight: 5 }} name="pie-chart-2" size={14} color="white" />
                    <Text style={styles.pieHideShowText}>{isPieVisible ? 'Hide' : 'Show'} Chart</Text>
                </TouchableOpacity>
            }
        </>
    )
}

const styles = StyleSheet.create({
    detailsContainer: {
        marginTop: 10
    },
    keyContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    keyItem: {
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: 10,
        marginRight: 15,
    },
    keyItemLabel: {
        marginLeft: 5,
        fontSize: FontSizes.small,
        fontWeight: '600',
        color: MainColors.darkGray
    },
    percentOfVotesLabel: {
        color: MainColors.mediumGray
    },
    pieHideShowButton: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: MainColors.primary,
        padding: 10,
        borderRadius: 4
    },
    pieHideShowText: {
        color: '#fff',
        letterSpacing: 0.5,
        fontSize: FontSizes.small,
        fontWeight: '600'
    },
});

export default PieChart;